(function ($) {

    $.fn.estatesRest = function () {
        console.log('here')
        var that = this;
        var container = $(this).find('.js-estates').first();
        var category = that.data('category');
        var firmId = that.data('firm-id');
        var apiUrl = that.data('api-url');


        var template = null;
        var nextUrl = null;
        var args = {
            'posts_per_page': 6,
            'page': 0,
            'category': category,
        }

        function hideButton() {
            $('.js-load-more').addClass('hide');
        }

        function showButton() {
            $('.js-load-more').removeClass('hide');
        }

        $('.js-load-more').on('click', function () {
            args.page = args.page + 1;
            getEstates(false);
        })

        function getEstates(replace, params) {
            that.addClass('is-loading')

            if (replace) {
                container.html('');
            }
            console.log('api_url', apiUrl)


            $.ajax({
                type: 'GET',
                url: nextUrl ? nextUrl : apiUrl + "estate/" + firmId + "/minisite",
                data: params,
                success: function (res) {
                    nextUrl = res.next;
                    var items = res.results;

                    items.map(function(item) {
                        item.audience = getDateTime(item.audience)
                    })
                    $.get({
                        url: '/wp-content/themes/5x5/templates/estates.html',
                        success: function (html) {
                            template = Handlebars.compile(html);

                            items = template({
                                items: items
                            })
                            if (nextUrl) {
                                showButton();
                            } else {
                                hideButton();
                            }
                            container.append(items);
                            that.removeClass('is-loading')
                            setIntersections();
                            initToShow();
                        },
                        error: function (err) {
                            console.log(err);
                        }
                    })
                },
            })
        }
        getEstates(true);
    }
}(jQuery));

$(function () {
    if ($('#js-estates').length) {
        $('#js-estates').estatesRest();
    }
});

function getDateTime(date) {
    var d = new Date(date);
    var day = d.getDay() < 10 ? '0' + d.getDay() : d.getDay();
    var month = parseInt(d.getMonth()) + 1 < 10 ? '0' + (parseInt(d.getMonth()) + 1) : parseInt(d.getMonth()) + 1;
    return day + '/' + month + '/' + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes();
}